import { DateTime } from 'luxon';
import { DropdownGridPicker } from './DropdownGridPicker';

interface DropdownYearPickerProps {
  height: number,
  isSelectable: (year: DateTime) => boolean,
  monthAndYear: DateTime,
  onYearChange: (year: number) => void,
}

export const FIRST_YEAR = 1900;
export const LAST_YEAR = 2099;

const years = Array.from({ length: LAST_YEAR - FIRST_YEAR + 1 }, (_, index) => {
  const year = FIRST_YEAR + index;
  return { id: `calendar-year-picker-${year}`, label: `${year}`, value: year };
});

export const DropdownYearPicker = ({
  height,
  isSelectable,
  monthAndYear,
  onYearChange,
}: DropdownYearPickerProps) => {
  const items = years.map((year) => ({
    ...year,
    isDisabled: !isSelectable(monthAndYear.set({ year: year.value })),
  }));

  return (
    <DropdownGridPicker
      height={height}
      items={items}
      onSelect={onYearChange}
      selectedValue={monthAndYear.year}
    />
  );
};
